export enum ResponseCodes {
	Ok = 200,
	Accepted = 202,
	Unauthorized = 401,
}
